<template>
  <div class="step2">
    <div class="switch-con">
      <CSwitch v-model="inputVisible" color="#4caf50">Is a PO required?</CSwitch>
    </div>
    <div class="input-con" v-if="inputVisible">
      <table>
        <tr>
          <td>PO Number:</td>
          <td><input id="input" type="text" v-model="inputData" class="input"></td>
        </tr>
        <tr>
          <td>Delivery Date:</td>
          <td><input id="input" type="date" v-model="inputPoDate" class="input"></td>
        </tr>
      </table>
    </div>
    <div class="button-con">
      <CButton color="green" text="Next"  @click="onNextClick"/>
      <div class="ml20">
        <CButton color="orange" text="Back" @click="onBack"/>
      </div>
      <div class="ml20">
        <CButton color="red" text="Cancel"  @click="onCancel"/>
      </div>
    </div>
  </div>
</template>

<script>
import CButton from "../common/CButton.vue";
import CSwitch from "../common/CSwitch.vue";

export default {
  name: 'Steps2',
  components:{
    CButton,
    CSwitch
  },
  props: {
    onNext: Function,
    onBack: Function,
    onCancel: Function,
  },
  data(){
    return{
      inputVisible: false,
      inputData: '',
      inputPoDate: ''
    }
  },
  computed: {
    // disabledBtn(){
    //   return this.inputVisible&&this.inputData==='';
    // }

  },
  mounted() {

  },
  methods: {
    onNextClick(){
      this.onNext({
        po_required: this.inputVisible,
        po_number: this.inputData,
        poDate: this.inputPoDate
      })
    }
  }
}
</script>